import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import type { ReactNode } from "react";

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: 24 }}>Yükleniyor...</div>;
  }

  // Giriş yoksa login’e yönlendir
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Her ihtimale karşı children null ise bile çökmesin
  return <>{children ?? null}</>;
}
